export const MESSENGER_IDS = ["telegram", "max"];

export const MESSENGERS = {
  telegram: {
    id: "telegram",
    label: "Telegram",
    shareHint: "Сотрудники открывают ссылку в Telegram-боте",
    pasteHint: "https://t.me/…?start=ID_сценария",
    botName: () =>
      (process.env.REACT_APP_BOT_NAME || "MoGame_bot").replace(/^@/, ""),
  },
  max: {
    id: "max",
    label: "MAX",
    shareHint: "Сотрудники открывают ссылку в боте MAX",
    pasteHint: "https://max.ru/…?start=ID_сценария",
    botName: () =>
      (process.env.REACT_APP_MAX_BOT_NAME || "se13903175_bot").replace(/^@/, ""),
  },
};

export function isMessengerId(value) {
  return MESSENGER_IDS.includes(value);
}

export function getMessengerMeta(messengerId) {
  return MESSENGERS[isMessengerId(messengerId) ? messengerId : "telegram"];
}

export function resolveMessenger({ userMessenger, gameMessenger } = {}) {
  if (isMessengerId(gameMessenger)) return gameMessenger;
  if (isMessengerId(userMessenger)) return userMessenger;
  return "telegram";
}

export function getGroupShareLink(gameId, messengerId = "telegram", botNameOverride) {
  const meta = getMessengerMeta(messengerId);
  const botName = (botNameOverride || meta.botName()).replace(/^@/, "");
  if (!gameId || !botName) return "";

  if (messengerId === "max") {
    return `https://max.ru/${botName}?start=${gameId}`;
  }

  return `https://t.me/${botName}?start=${gameId}`;
}

export function getAccessModeHint(messengerId = "telegram") {
  const label = getMessengerMeta(messengerId).label;
  return `Сотрудники проходят сценарий по общей ссылке в ${label}. Нужна активная бизнес-подписка по размеру команды.`;
}

export function getMessengerChannelLabel(messengerId = "telegram") {
  return getMessengerMeta(messengerId).label;
}

export function normalizeAvailableMessengers(settings = {}) {
  if (
    Array.isArray(settings.availableMessengers) &&
    settings.availableMessengers.length > 0
  ) {
    const filtered = settings.availableMessengers.filter(isMessengerId);
    if (filtered.length > 0) {
      return MESSENGER_IDS.filter((id) => filtered.includes(id));
    }
  }

  if (settings.messenger === "max") return ["max"];
  if (settings.messenger === "telegram") return ["telegram"];

  return [...MESSENGER_IDS];
}

export function deriveLegacyMessenger(availableMessengers = []) {
  const ids = availableMessengers.filter(isMessengerId);
  if (ids.length === 1) return ids[0];
  return "";
}

export function getProjectShareLinks(gameId, settingsOrMessengers) {
  const messengers = Array.isArray(settingsOrMessengers)
    ? settingsOrMessengers.filter(isMessengerId)
    : normalizeAvailableMessengers(settingsOrMessengers);

  return messengers.map((id) => ({
    id,
    label: getMessengerMeta(id).label,
    link: getGroupShareLink(gameId, id),
  }));
}

export function getAccessModeHintForMessengers(messengerIds) {
  const ids =
    Array.isArray(messengerIds) && messengerIds.length > 0
      ? messengerIds.filter(isMessengerId)
      : [...MESSENGER_IDS];

  if (ids.length === 1) {
    return getAccessModeHint(ids[0]);
  }

  const labels = ids.map((id) => getMessengerMeta(id).label).join(" и ");
  return `Сотрудники проходят сценарий по общей ссылке в ${labels}. Нужна активная бизнес-подписка по размеру команды.`;
}
